import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueTyperPlugin from 'vue-typer'
import Layout from './layouts/Layout'
import vClickOutside from 'v-click-outside'
import './assets/sass/main.scss'
import 'vue2-animate/dist/vue2-animate.min.css'

Vue.config.productionTip = false

Vue.component('layout', Layout)
Vue.use(VueTyperPlugin)
Vue.use(vClickOutside)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
